import React from 'react'
import TradingHoursList from '@scentregroup/shared/components/trading-hours-list'
import { conciergeTitle } from '@scentregroup/shared/helpers/concierge'
import PlanVisitUtilityBox from '@scentregroup/shared/components/plan-visit-utility-box'
import { Box } from '@hub/box'
import { Text } from '@hub/text'
import { Stack } from '@hub/stack'
import { CoreContainer } from '@hub/core-container'
import classNames from 'classnames'
import { TradingHourDay } from '@scentregroup/shared/graphql'
import { Centre } from '../../../lib/get-centre-by-slug'
import { H3 } from '@hub/heading'

export const OpeningHours: React.FC<
  React.PropsWithChildren<{
    centre: Centre
    centreTradingHours: TradingHourDay[]
    minDays: number
  }>
> = ({ centre, centreTradingHours, children, minDays }) => (
  <CoreContainer>
    <H3 as="h1" align="center">
      {`Westfield ${centre.title} opening hours`}
    </H3>
    <Stack
      shouldWrapChildren={false}
      direction={['column', 'column', 'row']}
      gap={['spacing-lg', 'spacing-lg', 'spacing-xl']}
      sx={{
        marginTop: ['spacing-md', 'spacing-md', 'spacing-xl'],
        marginBottom: 'spacing-xl',
      }}
      flexGrow={0}
    >
      <Box
        flex="1"
        sx={{
          flex: '1 1 60%',
          marginRight: [0, 'spacing-sm', 'spacing-4xl'],
        }}
      >
        {centre.slug === 'bondijunction' ? (
          <Box>
            <Text
              sx={{
                marginBottom: 'spacing-sm',
              }}
            >
              Westfield Bondi Junction will be closed on Wednesday 17 April.
            </Text>
            <Text
              sx={{
                marginBottom: 'spacing-sm',
              }}
            >
              A Community Reflection Day will be held on Thursday 18 April at
              Westfield Bondi. Retailers will not be open on this day.
            </Text>
            <Text
              sx={{
                marginBottom: 'spacing-sm',
              }}
            >
              Community and customers are welcome to visit the centre and pay
              their respects, between 11:00am and 5:00pm.
            </Text>
            <Text
              sx={{
                marginBottom: 'spacing-sm',
              }}
            >
              Retailers will start to open for trade from Friday 19 April.
            </Text>
          </Box>
        ) : (
          <TradingHoursList
            minDays={minDays}
            openDaysHeading="Days"
            openHoursHeading="Hours"
            centreTradingHours={{
              tradingHours: centreTradingHours,
              features: centre.features,
              timeZone: centre.timeZone,
            }}
          />
        )}
        <Box sx={{ marginTop: 'spacing-md' }}>{children}</Box>
      </Box>
      <Box flex="1" sx={{ flexBasis: '35%', marginTop: 'spacing-4xl' }}>
        <PlanVisitUtilityBox
          heading={conciergeTitle(centre.country, centre.slug)}
          address={centre.physicalAddress}
          address2={`${centre.suburb} ${centre.state} ${centre.postcode}`}
          phoneNumber={centre.telephoneNumber}
          email={centre.emailAddress}
          conciergeService={centre.conciergeService}
          centreSlug={centre.slug}
          latitude={centre.latitude}
          longitude={centre.longitude}
          country={centre.country}
        />
        <div className={classNames('sc-slot', 'sc-slot-sub-concierge')} />
      </Box>
    </Stack>
  </CoreContainer>
)
